export const JOBS = [
	{
		companyName: 'Ivy',
		companyLink: 'https://www.ivyapp.com.co',
		date: {start: new Date(2025, 1), end: new Date()},
		positionEN: 'Mobile Developer',
		positionES: 'Desarrolladora Móvil',
		summaryEN:
			'Built a cross-platform event management app with React Native, TypeScript, NativeWind, Supabase, Wompi, and Maps, with automated App Store and Play releases.',
		summaryES:
			'Desarrollo de una app multiplataforma para gestión de eventos con React Native, TypeScript, NativeWind, Supabase, Wompi y Maps, con despliegues automáticos.',
	},
	{
		companyName: 'Piyion',
		companyLink: 'https://piyion.com',
		date: {start: new Date(2022, 5), end: new Date()},
		positionEN: 'Frontend Web/Mobile Developer',
		positionES: 'Desarrolladora Frontend Web/Móvil',
		summaryEN:
			'Built scalable web and mobile products with React, TypeScript, Firebase, and React Native, improving performance, deployment flow, and UX.',
		summaryES:
			'Desarrollo de productos web y móviles escalables con React, TypeScript, Firebase y React Native, mejorando rendimiento, despliegues y UX.',
	},
	{
		companyName: 'Ninus Design & Technology',
		companyLink: 'https://ninus.co',
		date: {start: new Date(2022, 2), end: new Date(2022, 5)},
		positionEN: 'Frontend Web Developer',
		positionES: 'Desarrolladora Frontend Web',
		summaryEN:
			'Developed responsive React and SCSS interfaces, integrated REST APIs, and worked with designers and backend teams to ship polished UI experiences.',
		summaryES:
			'Desarrollo de interfaces responsive con React y SCSS, integración de APIs REST y colaboración con diseño y backend para entregar experiencias UI pulidas.',
	},
];
